import CircularProgress from "@mui/material/CircularProgress";
import { Select } from "../Select/Select";
import classNames from "classnames";
import { useState } from "react";
import { useTemplateStoreFromContext } from "./Context/hooks";
import { useShallow } from "zustand/react/shallow";

const { Option } = Select;

const formatVersionNumber = (v: string) =>
  `v${v.slice(1, 5)}-${v.slice(5, 7)}-${v.slice(7, 9)}`;

export default function VersionSelector() {
  // Access the store with the correct parameters
  const {
    changeTemplateVersion,
    updateTemplateVersion,
    availableVersions,
    templateVersion,
    defaultVersion,
  } = useTemplateStoreFromContext()(
    useShallow(state => ({
      changeTemplateVersion: state.changeTemplateVersion,
      updateTemplateVersion: state.updateTemplateVersion,
      availableVersions: state.availableVersions,
      templateVersion: state.templateVersion,
      defaultVersion: state.defaultVersion,
    }))
  );

  const [savingVersion, setSavingVersion] = useState<boolean>(false);

  return (
    <div className="cms-updates__counter" style={{ width: "300px" }}>
      <div className="main-input">
        <label htmlFor={"TemplateSelect"} className="main-input__label">
          Template Version
        </label>
        <Select
          value={templateVersion || defaultVersion}
          onChange={v => changeTemplateVersion(v)}
          style={{ width: "150px" }}
          optionLabelProp="Select Version"
          data-testid="TemplateSelect"
          placement="topRight"
          id="TemplateSelect"
        >
          {availableVersions.map(version => (
            <Option
              key={version}
              data-testid={`TemplateOption${version}`}
              value={version}
            >
              {formatVersionNumber(version)}
            </Option>
          ))}
        </Select>
      </div>
      <button
        onClick={() => {
          setSavingVersion(true);
          updateTemplateVersion(null).finally(() => setSavingVersion(false));
        }}
        className={classNames({
          "rounded-btn": true,
          "rounded-btn--blue": true,
        })}
        style={{
          marginLeft: "20px",
          fontSize: "12px",
          width: "150px",
          height: "10%",
          marginTop: "7%",
          ...(savingVersion && { backgroundColor: "#ffffff" }),
        }}
      >
        {!savingVersion ? "Publish Version" : <CircularProgress size={16} />}
      </button>
    </div>
  );
}
